<button mat-button value="bold" id="btnProfileMenu" [matMenuTriggerFor]="menu" class="header-profile-button" tabindex="1">
  {{ 'titleHello.TITLE' | translate }} {{ userName }}
</button>
<img id="icon_user" src="./assets/img/user.svg" title="{{ 'userProfile.TITLE' | translate }}" (click)="openMenu()" alt="{{ 'userProfile.TITLE' | translate }}" />
<app-itau-modal [logo]="false" [show]="menuOpened" (close)="onCloseMenu($event)" [title]="'userProfile.TITLE' | translate">
  <app-user-profile></app-user-profile>
</app-itau-modal>
<mat-menu #menu="matMenu" class="header-profile-menu">
  <app-user-profile></app-user-profile>
</mat-menu>